<template>
  <div class="common-home-content space_pl space_pr" v-show="show">
    <h3 class="case-title">{{title}}</h3>
    <div v-if="caseDate.first && caseDate.first.length > 0">
      <div
        v-for="(child, index) in caseDate.first"
        :key="index"
      >
        <p 
          class="case-text"
          v-for="(child2, value_index) in child.value"
          :key="value_index"
          :class="value_index > 0?'indent':''"
        ><span class="label" v-if="value_index == 0">{{child.name}}：</span>{{child2}}<span class="case-use-btn" @click="handleUse(caseDate.first, child2)" v-if="child.name == '方剂组成'">使用</span></p>
      </div>
    </div>
    <div v-if="caseDate.followups && caseDate.followups.length > 0">
      <div
        v-for="(followup, followup_index) in caseDate.followups"
        :key="followup_index"
      >
        <p class="diagnosis-num">【{{diagnosisFormat(followup_index+2)}}】</p>
        <div
          v-for="(child, index) in followup"
          :key="index"
        >
          <p 
            class="case-text"
            v-for="(child2, value_index) in child.value"
            :key="value_index"
            :class="value_index > 0?'indent':''"
          ><span v-if="value_index == 0">{{child.name}}：</span>{{child2}}<span class="case-use-btn" @click="handleUse(followup, child2)" v-if="child.name == '方剂组成'">使用</span></p>
        </div>
      </div>
    </div>
    <van-popup v-model="kf_popup_show" :close-on-click-overlay="false">
      <div class="kf-popup-window">
        <p class="title">使用成功，该方剂已复制到</p>
        <p class="prompt">添加药材-备注栏</p>
        <div class="img-content">
          <img src="../../assets/images/doctor/kangfang.png" alt="" />
          <div class="remarks">
            <p>备注：</p>
            <p>黄芪10g 白术20g 炙甘草10g 党参15g</p>
          </div>
        </div>
        <div class="btns clearfix">
          <button class="fl left" @click="handleClosePopup">再看看</button>
          <button class="fr right" @click="handleConfirmKf">去开方</button>
        </div>
      </div>
    </van-popup>
  </div>
</template>
<script>
import { _ } from "vue-underscore";
import http from "../../util/iapetusApiConfig";
export default {
  data() {
    return {
      show: false,
      kf_popup_show: false,
      token: "",
      doctor_id: 1,
      case_id: 1,
      title: "",
      caseDate: {},
      prescription: "",
      provenace: ""
    };
  },
  created() {
    this.case_id = this.$route.params.id;
    var user_info = this.$appUtils.appData();
    if (user_info) {
      this.doctor_id = user_info.doctor_id;
      this.token = user_info.token;
    }
    this.getDate();
    window.appBack = () => this.pageback();
  },
  methods: {
    diagnosisFormat(num) {
      var places = ["", "十", "百", "千", "万"];
      var chars = ["零", "一", "二", "三", "四", "五", "六", "七", "八", "九"];
      var digits = num.toString().split("");
      if (digits.length > places.length) {
        return "Overflow";
      }
      var result = "";
      for (var i = 0; i < digits.length; ++i) {
        var digit = parseInt(digits[i]);
        var place = places[digits.length - i - 1];
        switch (digit) {
          case 0:
            if ("" != result && "零" != result.slice(-1)) {
              result += chars[0];
            }
            break;
          case 1:
            if ("" != result || "十" != place) {
              result += chars[digit];
            }
            result += place;
            break;
          default:
            result += chars[digit];
            result += place;
            break;
        }
      }
      if (result.slice(-1) == "零") {
        return result.slice(0, -1);
      }
      return result + "诊";
    },
    getDate() {
      let that = this;
      http
        .get("/studio/medical_cases/" + that.case_id, {
          headers: {
            Authorization: that.token
          }
        })
        .then(function(res) {
          if (res.data.status_code == 200) {
            that.title = res.data.data.title;
            that.caseDate = res.data.data.detail;
          }
          that.show = true;
        });
    },
    handleUse(arr, value) {
      let item = _.filter(arr, function(obj) {
        return obj["name"] == "出处";
      })[0];
      if (item) {
        this.provenace = item["value"][0];
      } else {
        this.provenace = "";
      }
      this.prescription = value;
      this.kf_popup_show = true;
    },
    handleClosePopup() {
      this.kf_popup_show = false;
    },
    handleConfirmKf() {
      localStorage.removeItem("case_keyword");
      this.$appUtils.appSendKffz({
        prescription: this.prescription,
        provenace: this.provenace,
        providerInfo: this.$route.query.providerInfo
      });
    },
    pageback() {
      window.history.back();
      return true;
    }
  }
};
</script>
<style lang="scss" scoped>
.common-home-content {
  padding-bottom: 10px;
}
.common-home-content-pt {
  padding-top: 50px;
}
.case-title {
  margin-top: 30px;
  margin-bottom: 27px;
  line-height: 17px;
  font-size: 17px;
  font-family: PingFang-SC-Heavy;
  font-weight: 800;
  color: #ac4b38;
}
.diagnosis-num {
  margin-top: 26px;
  line-height: 22px;
  font-size: 16px;
  font-family: PingFang-SC-Heavy;
  font-weight: 800;
  color: #333333;
}
.case-text {
  margin-top: 26px;
  line-height: 22px;
  font-size: 16px;
  font-family: PingFang-SC-Medium;
  font-weight: 500;
  color: #333333;
  .label {
    font-family: PingFang-SC-Bold;
    font-weight: Bold;
    color: #666666;
  }
}
.indent {
  text-indent: 32px;
}
.case-use-btn {
  margin-left: 15px;
  display: inline-block;
  width: 55px;
  height: 24px;
  line-height: 24px;
  font-size: 14px;
  font-family: PingFang-SC-Medium;
  font-weight: 500;
  color: #ffffff;
  text-align: center;
  background: #ac4b38;
  border-radius: 12px;
}
.kf-popup-window {
  width: 300px;
  box-sizing: border-box;
  padding: 20px 25px 20px 25px;
  .title {
    font-size: 16px;
    font-family: PingFang-SC-Medium;
    font-weight: 500;
    color: #333333;
    line-height: 16px;
    text-align: center;
  }
  .prompt {
    margin-top: 14px;
    font-size: 16px;
    font-family: PingFang-SC-Medium;
    font-weight: 500;
    color: #fd4343;
    line-height: 20px;
    text-align: center;
  }
  .img-content {
    display: block;
    margin: 29px auto 0;
    width: 162px;
    position: relative;
    img {
      width: 100%;
    }
    .remarks {
      width: 227px;
      box-sizing: border-box;
      padding: 5px 10px;
      background: #ffffff;
      box-shadow: 0px 2px 5px 1px rgba(35, 24, 21, 0.15);
      border-radius: 5px;
      margin-left: -114px;
      position: absolute;
      left: 50%;
      top: 114px;
      & > p {
        line-height: 17px;
        font-size: 12px;
        font-family: PingFang-SC-Medium;
        font-weight: 500;
        color: #333333;
      }
    }
  }
  .btns {
    margin-top: 30px;
    width: 100%;
    box-sizing: border-box;
    .left {
      width: 120px;
      line-height: 30px;
      font-size: 15px;
      font-family: PingFang-SC-Medium;
      font-weight: 500;
      color: rgba(172, 76, 56, 1);
      text-align: center;
      border: 1px solid rgba(172, 76, 56, 1);
      border-radius: 4px;
    }
    .right {
      width: 120px;
      line-height: 32px;
      font-size: 15px;
      font-family: PingFang-SC-Medium;
      font-weight: 500;
      color: #fff;
      text-align: center;
      background-color: rgba(172, 76, 56, 1);
      border-radius: 4px;
    }
  }
}
.van-popup {
  border-radius: 10px;
}
</style>
<style>
</style>



// WEBPACK FOOTER //
// src/components/doctor/andetail.vue